import { useTranslation } from 'react-i18next';
import SurveyEditor from '../../../components/homepage/survey/SurveyEditor';
import SimpleHeader from '../../../components/layout/SimpleHeader';

const SurveyCreate = () => {
  const { t } = useTranslation();

  return (
    <div className="content scrollbar">
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.survey.title2')}
      />
      <SurveyEditor />
    </div>
  );
};

export default SurveyCreate;
